export const capitalizeFirstLetter = (s: string) => `${s.charAt(0).toUpperCase()}${s.slice(1)}`;

export const roundValue = (value: number, decimals: number) => (
  Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`) || null
)

export const isFloat = (n: number) => Number(n) === n && n % 1 !== 0

// getAmount(10) => 10
// getAmount(10.1) => 10.10
// getAmount(10.123) => 10.12
export const getRoundedAmount = (amount: number): string => {
  const rounded = amount.toFixed(2);
  return rounded.endsWith('.00') ? String(parseInt(rounded, 10)) : rounded;
}

export const getRoundedDollar = (amountInCents: number): string => {
  const dollars = amountInCents / 100;
  return getRoundedAmount(dollars)
}
